import { Icon } from "@circle-react-shared/Icon";
import { Dropdown } from "@circle-react-shared/uikit/Dropdown";
import { Typography } from "@circle-react-shared/uikit/Typography";

interface FilterOption {
  readonly text: string;
  readonly value: string;
}

interface FilterDropdownProps {
  activeItem: string;
  data: readonly FilterOption[];
  dataTestId?: string;
  onItemClick: (value: string) => void;
}

export const FilterDropdown = ({
  activeItem,
  data,
  onItemClick,
  dataTestId,
}: FilterDropdownProps) => {
  const activeItemText =
    data.find(item => item.value === activeItem)?.text || "";

  return (
    <div className="w-full">
      <Dropdown
        direction="bottom-start"
        className="w-full"
        buttonClassName="w-full"
        menuItemsClassName="!w-full min-w-40 !p-2"
        buttonDataTestId={dataTestId}
        button={
          <Dropdown.MenuButton className="hover:bg-secondary-dark border-primary flex w-full min-w-0 justify-between !gap-1 rounded-md border bg-transparent !py-1.5 pl-4 pr-2 transition-colors">
            <div className="flex min-w-0 flex-1 gap-x-2 overflow-hidden">
              <div className="min-w-0 truncate">
                <Typography.LabelSm weight="medium">
                  {activeItemText}
                </Typography.LabelSm>
              </div>
            </div>
            <Icon
              size={16}
              type="16-chevron-triangle-down-small"
              className="text-dark shrink-0"
            />
          </Dropdown.MenuButton>
        }
      >
        {data.map((item: FilterOption) => {
          const { value, text } = item;
          return (
            <Dropdown.Item key={value} onClick={() => onItemClick(value)}>
              <Dropdown.ItemLink
                type="button"
                active={activeItem === value}
                aria-label={text}
              >
                <div className="flex min-w-0 items-center gap-x-2">
                  <span className="truncate text-sm">{text}</span>
                </div>
              </Dropdown.ItemLink>
            </Dropdown.Item>
          );
        })}
      </Dropdown>
    </div>
  );
};
